import { EventEmitter, Output, ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';

@Component({
  selector: 'aims-grid-selector',
  template: `&nbsp;<span class="button-label"> Grid View: </span>
    <mat-button-toggle-group [value]="grid" aria-label="Grid View">
      <mat-button-toggle value="basic" (change)="setGrid('basic')">Basic</mat-button-toggle>
      <mat-button-toggle value="full" (change)="setGrid('full')">Full</mat-button-toggle>
    </mat-button-toggle-group>`,
  styleUrls: ['./aims-grid-selector.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AimsGridSelectorComponent implements OnInit {
  static BASIC: string = 'basic';
  static FULL: string = 'full';

  constructor(private transferHttp: TransferHttpService) {
  }

  @Output() gridSelected: EventEmitter<string> = new EventEmitter<string>();

  _gridKey: string;
  @Input() set gridKey(val: string) {
    this._gridKey = val;
  }

  get gridKey() {
    return this._gridKey;
  }

  //***************************
  // Variables
  //***************************

  user = this.transferHttp.getCache('user');

  grid: string;

  //***************************
  // Functions
  //***************************

  setGrid(grid:string) {
    sessionStorage.setItem(this.gridKey, grid);
    this.grid = grid;
    this.gridSelected.emit(grid);
  }


  //***************************
  // Init
  //***************************
  ngOnInit() {
    if (!this.gridKey || this.gridKey.length == 0) {
      this.gridKey = 'Grid';
    }
    let key:string = 'default' + this.gridKey.charAt(0).toUpperCase() + this.gridKey.slice(1);

    if (this.user) {
      this.grid = sessionStorage.getItem(this.gridKey) || this.user[key] || 'basic';
    }
    else {
      this.grid = sessionStorage.getItem(this.gridKey) || 'basic';
    }
    this.gridSelected.emit(this.grid);
  }
}
